import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface PageHeaderProps {
    title: ReactNode
    description?: ReactNode
    eyebrow?: ReactNode
    actions?: ReactNode
    className?: string
}

const PageHeader: FC<PageHeaderProps> = ({
    title,
    description,
    eyebrow,
    actions,
    className
}): ReactNode => {
    return (
        <div className={cn('flex flex-col gap-4 md:flex-row md:items-end md:justify-between', className)}>
            <div className='min-w-0'>
                {eyebrow && <div className='mb-2'>{eyebrow}</div>}

                <h1 className='font-heading text-2xl font-semibold tracking-tight text-balance sm:text-[1.75rem]'>
                    {title}
                </h1>

                {description && (
                    <p className='mt-1.5 max-w-2xl text-sm text-muted-foreground text-pretty'>
                        {description}
                    </p>
                )}
            </div>

            {actions && <div className='flex flex-wrap items-center gap-2'>{actions}</div>}
        </div>
    )
}

export default PageHeader
